import React from 'react'
import './v3-profile-routes.css'

interface V3ProfileRouteShellProps {
  children: React.ReactNode
}

export default function V3ProfileRouteShell({ children }: V3ProfileRouteShellProps) {
  return (
    <div className="v3-profile-route py-6">
      <div className="mx-auto w-[95%] min-w-0">
        <div className="v3-profile-route__content min-w-0">
          {children}
        </div>
      </div>
    </div>
  )
}

